module.exports = __webpack_public_path__ + "img/sales.19277808.svg";